export const profile = (state) => {
  return state.profile;
};
